import axios from 'axios'

axios.defaults.baseURL = '/api';


// Add a response interceptor to check login
axios.interceptors.response.use( response => response.data
, (error) => {
    if(error.response.data.status == 'error' && error.response.data.code == 401){
        window.location.href = '/mietanzeige-inserieren-login';
    }
    return Promise.reject(error);
});

//add json headers 
axios.defaults.headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};

export default axios;